"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorToolTip = void 0;
const react_1 = __importStar(require("react"));
const router_1 = require("next/router");
const Tooltip_1 = __importDefault(require("../Animation/Tooltip"));
const JourneyAppContext_1 = require("../../contexts/JourneyAppContext");
const ErrorToolTip = () => {
    const { error, setError } = react_1.useContext(JourneyAppContext_1.JourneyAppContext);
    /* If the page changes, get rid of our tooltip. */
    react_1.useEffect(() => {
        router_1.Router.events.on('routeChangeStart', () => {
            setError(undefined);
        });
    }, [setError]);
    return (react_1.default.createElement(Tooltip_1.default, { targetRef: error === null || error === void 0 ? void 0 : error.ref, isOpen: error, className: "danger" },
        react_1.default.createElement("div", { className: "flex space-x-2 text-sm items-center max-w-[15rem]" },
            react_1.default.createElement("div", { className: "break-words" }, error === null || error === void 0 ? void 0 : error.message),
            react_1.default.createElement("button", { className: "flex items-center flex-shrink-0 size-sm justify-center", onClick: () => { setError(undefined); } },
                react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", style: { fill: 'rgba(255, 255, 255, 1)', transform: 'msFilter' } },
                    react_1.default.createElement("path", { d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.207 12.793-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z" }))))));
};
exports.ErrorToolTip = ErrorToolTip;
